export const logException = (e: Error, message?: string) => {
    if (message) {
        console.log(message, e)
    } else {
        console.log(e)
    }
}